<div class="swiper-container">
    <swiper *ngIf="bannerList && bannerList.Records && screenWidth > 576" [slidesPerView]="1" [spaceBetween]="5" [loop]="true"
        [autoplay]="{ delay: 5000, disableOnInteraction: false }">
        <ng-template *ngFor="let banner of bannerList.Records" swiperSlide data-swiper-autoplay="5000"
            class="swiper-slide">
                <img src="{{banner.ImageSource}}" alt="banner">
        </ng-template>
    </swiper>

    <swiper *ngIf="bannerList && bannerList.Records && screenWidth <= 576" [slidesPerView]="1" [spaceBetween]="5" [loop]="true"
        [autoplay]="{ delay: 5000, disableOnInteraction: false }">
        <ng-template *ngFor="let banner of bannerList.Records" swiperSlide data-swiper-autoplay="5000"
            class="swiper-slide">
            <img src="{{banner.MobileImageSource}}" alt="banner">
        </ng-template>
    </swiper>
</div>



<!-- <swiper *ngIf="language === 'en'" [slidesPerView]="1" [spaceBetween]="5" [loop]="true"
    [autoplay]="{ delay: 5000, disableOnInteraction: false }">
    <ng-template *ngFor="let banner of banners" swiperSlide data-swiper-autoplay="5000" class="swiper-slide">
        <img src="{{banner.Image}}" alt="banner" class="w-100 h-100">
    </ng-template>
</swiper>
<swiper *ngIf="language === 'cn'" [slidesPerView]="1" [spaceBetween]="5" [loop]="true"
    [autoplay]="{ delay: 5000, disableOnInteraction: false }">
    <ng-template *ngFor="let banner of banners" swiperSlide data-swiper-autoplay="5000" class="swiper-slide">
        <img src="{{banner.ImageCn?banner.ImageCn:banner.Image}}" alt="banner" class="w-100 h-100">
    </ng-template>
</swiper>
<swiper *ngIf="language === 'my'" [slidesPerView]="1" [spaceBetween]="5" [loop]="true"
    [autoplay]="{ delay: 5000, disableOnInteraction: false }">
    <ng-template *ngFor="let banner of banners" swiperSlide data-swiper-autoplay="5000" class="swiper-slide">
        <img src="{{banner.ImageMy?banner.ImageMy:banner.Image}}" alt="banner" class="w-100 h-100">
    </ng-template>
</swiper>
<swiper *ngIf="language === 'th'" [slidesPerView]="1" [spaceBetween]="5" [loop]="true"
    [autoplay]="{ delay: 5000, disableOnInteraction: false }">
    <ng-template *ngFor="let banner of banners" swiperSlide data-swiper-autoplay="5000" class="swiper-slide">
        <img src="{{banner.ImageTh?banner.ImageTh:banner.Image}}" alt="banner" class="w-100 h-100">
    </ng-template>
</swiper>
<swiper *ngIf="language === 'vn'" [slidesPerView]="1" [spaceBetween]="5" [loop]="true"
    [autoplay]="{ delay: 5000, disableOnInteraction: false }">
    <ng-template *ngFor="let banner of banners" swiperSlide data-swiper-autoplay="5000" class="swiper-slide">
        <img src="{{banner.ImageVn?banner.ImageVn:banner.Image}}" alt="banner" class="w-100 h-100">
    </ng-template>
</swiper>
<swiper *ngIf="language === 'id'" [slidesPerView]="1" [spaceBetween]="5" [loop]="true"
    [autoplay]="{ delay: 5000, disableOnInteraction: false }">
    <ng-template *ngFor="let banner of banners" swiperSlide data-swiper-autoplay="5000" class="swiper-slide">
        <img src="{{banner.ImageId?banner.ImageId:banner.Image}}" alt="banner" class="w-100 h-100">
    </ng-template>
</swiper> -->